<template>
  <div class="col-12">
    <m-category-wrapper>
      <template v-slot="{ categories,imageHandler ,setLinkType}">
        <div class="row">
          <div v-for="category in categories" :key="category.id" :class="categoryItemClass">
            <m-a :href="setLinkType(category,linkType)" >
              <component :is="categoryCardName" :category="category"/>
            </m-a>
          </div>
        </div>
      </template>
    </m-category-wrapper>
  </div>
</template>

<script>
import mCategoryWrapper from "../../Wrappers/CategoryWrapper";
import mA from '../../Tags/A'
import mCategoryCard900 from "../../Category/Card/CategoryCard900";
import {Cards} from "../Card/Cards";

export default {
  name: "Categories313",
  components: {mCategoryWrapper, mA, mCategoryCard900, ...Cards},
  props: {
    categoryItemClass: {
      default: 'col-lg-4 my-2'
    },
    linkType: {
      options: ['blog', 'SingleCategory', 'Products'],
      default: 'SingleCategory'
    },
    categoryCardName: {
      default: 'mCategoryCard900',
      options: Object.keys(Cards)
    },
  },
}
</script>

<style scoped>

</style>